const IS_PROD = process.env.NODE_ENV === "production";

const logger = {
  error: (message, meta = {}) => {
    if (!IS_PROD) {
      console.error(`❌ ${message}`, meta);
    }
    // Hook Sentry / LogRocket here
  },
  warn: (message, meta = {}) => {
    if (!IS_PROD) console.warn(`⚠️ ${message}`, meta);
  },
  info: (message, meta = {}) => {
    if (!IS_PROD) console.info(`ℹ️ ${message}`, meta);
  },
};

export default logger;
